import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { formatApiError } from '../utils/helpers';
import { Lock, User } from '@phosphor-icons/react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_parkdesk-pro/artifacts/ty0wykz2_R6uvV.jpg';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      setError('Por favor ingrese usuario y contraseña');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      await login(username.trim(), password);
    } catch (err) {
      setError(formatApiError(err) || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-4 relative overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 opacity-[0.08] bg-no-repeat bg-center bg-contain pointer-events-none"
        style={{ 
          backgroundImage: `url(${LOGO_URL})`,
          backgroundSize: '60%',
          filter: 'grayscale(30%)'
        }}
      />
      
      {/* Content */}
      <div className="w-full max-w-md relative z-10">
        {/* Logo/Header */}
        <div className="text-center mb-8">
          <img 
            src={LOGO_URL} 
            alt="Glandymar" 
            className="w-32 h-32 mx-auto mb-4 rounded-2xl object-contain bg-white/10 p-2"
          />
          <h1 className="text-3xl font-heading text-white mb-2">GLANDYMAR</h1>
          <p className="text-[#A1A1AA]">Sistema de Gestión de Estacionamiento</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="bg-[#141414]/95 backdrop-blur-sm rounded-xl p-6 border border-[#27272A]">
          {error && (
            <div className="bg-[#450A0A] border border-[#DC2626] text-[#FCA5A5] px-4 py-3 rounded-lg mb-6 text-sm" data-testid="login-error">
              {error}
            </div>
          )}

          <div className="space-y-4">
            <div>
              <label className="block text-[#A1A1AA] text-sm mb-2 uppercase tracking-wide">Usuario</label>
              <div className="relative">
                <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#71717A]" weight="bold" />
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full bg-[#0A0A0A] border border-[#27272A] rounded-lg pl-12 pr-4 py-4 text-white text-lg focus:border-[#16A34A] focus:outline-none transition-colors"
                  placeholder="Ingrese su usuario"
                  autoFocus
                  autoComplete="username"
                  data-testid="login-username"
                />
              </div>
            </div>

            <div>
              <label className="block text-[#A1A1AA] text-sm mb-2 uppercase tracking-wide">Contraseña</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#71717A]" weight="bold" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-[#0A0A0A] border border-[#27272A] rounded-lg pl-12 pr-4 py-4 text-white text-lg focus:border-[#16A34A] focus:outline-none transition-colors"
                  placeholder="Ingrese su contraseña"
                  autoComplete="current-password"
                  data-testid="login-password"
                />
              </div>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full mt-6 bg-[#16A34A] hover:bg-[#15803D] text-white font-semibold py-4 rounded-lg text-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="login-submit"
          >
            {loading ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>

        <p className="text-center text-[#71717A] text-sm mt-6">
          Chile - Zona Horaria: Santiago
        </p>
      </div>
    </div>
  );
}
